/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import {
  Box, Button, IconButton, Skeleton, Stack, TextField,
} from '@mui/material';
import { ControlPointRounded, DeleteOutlineRounded, EditOutlined } from '@mui/icons-material';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { createAdminAddOns, deleteAdminAddOns, getAdminAddOns } from '../../../../Redux/Models/master';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import Images from '../../../../Configs/images';
import { formatNumToCurrency } from '../../../../Utils/helpers';
import { IconEdit, IconTrash } from '../../../../Assets/Icons';

const initialAddonForm = {
  title: '',
  description: '',
  price: '',
  extra: '',
};

export default function Component({
  classes, error, message, isLoadingAddOns, addOns, isLoading, updatedAddons,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { openAlert } = useContext(AlertContext);
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  const [openForm, setOpenForm] = useState(false);
  const [fields, setFields] = useState(() => initialAddonForm);

  const handleOpenForm = (data) => {
    setOpenForm(true);
    if (data) {
      setFields(data);
    }
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setFields(initialAddonForm);
  };

  const handleChangeField = (e) => {
    setFields({
      ...fields,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getAdminAddOns());
  }, []);

  useEffect(() => {
    if (updatedAddons) {
      handleCloseForm();
      closeConfirmation();
      openAlert({
        message: `${message}`,
        severity: 'success',
      });
    }
  }, [updatedAddons]);

  const handleCreateAddon = () => {
    const body = {
      title: fields.title,
      description: fields.description,
      price: fields.price,
      extra: fields.extra,
    };
    if (fields.id) {
      // do update || no ednpoint yet
    } else {
      dispatch(createAdminAddOns(body));
    }
  };

  const handleDeleteAddon = (idAddon) => {
    openConfirmation({
      title: 'Delete this addon?',
      desc: 'Once you delete it, you can\'t take it back',
      confirmText: 'Delete',
      cancelText: 'Close',
      handleAgree: () => {
        dispatch(deleteAdminAddOns(idAddon));
      },
      handleClose: () => {
        closeConfirmation();
      },
    });
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <strong>Extra Storage Package</strong>
          <Box fontSize={12} className="mute" mt={1}>
            Available
            {' '}
            {addOns.length}
            {' '}
            packages
          </Box>
        </Box>
        <Box>
          <Button startIcon={<ControlPointRounded />} className="btn-outlined" variant="outlined" onClick={handleOpenForm}>Add New</Button>
        </Box>
      </Box>

      <Stack direction="column" gap={1.5} mt={2}>
        {isLoadingAddOns ? (
          <Box className="mt-3">
            {new Array(2).fill(1).map((e, index) => (
              <Box className="tracking-box" key={index} mb={2}>
                <div className="flex space-between mt-2">
                  <div style={{ width: '65%' }}>
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="text" width="60%" />
                  </div>
                  <div>
                    <Skeleton variant="text" width={80} />
                  </div>
                </div>
              </Box>
            ))}
          </Box>
        ) : addOns.map((addon) => (
          <Box
            key={addon.id}
            border="1px solid #E5E5E5"
            py={1}
            px={1.5}
            borderRadius="10px"
          >
            <Box
              display="flex"
              justifyContent="space-between"
            >
              <Box>
                <Box display="flex" alignItems="center" gap={0.5} fontSize={14} fontWeight="700">
                  <img alt="extra storage" src={Images.BoxOutlined} width="11px" height="11px" />
                  {addon.extra}
                  {' '}
                  Storages
                </Box>
                <Box display="flex" alignItems="center" gap={0.5} fontSize={12} mt={1} className="mute">
                  <img alt="euro" src={Images.Euro} width="11px" height="11px" />
                  <span>
                    Extra
                    {' '}
                    {addon.extra}
                    {' '}
                    storages only
                  </span>
                  {' '}
                  <span className="weight-700">
                    {formatNumToCurrency(Number(addon.price))}
                  </span>
                </Box>
              </Box>
              <Box>
                <Button variant="outlined" className="btn-outlined" disabled size="small">Buy</Button>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2} mt={2} mr={2} mb={2}>
              <Box display="flex" alignItems="center" gap={1} color="#004C3B" fontSize={12} fontWeight="600" className="link" onClick={() => handleDeleteAddon(addon.id)}>
                <IconTrash iconcolor="#004C3B" sx={{ fontSize: 20 }} />
                Delete
              </Box>
              {/* <Box display="flex" alignItems="center"
              gap={1} color="#004C3B" fontSize={12} fontWeight="600" className="link">
                <IconEdit iconcolor="#004C3B" sx={{ fontSize: 20 }} />
                Edit
              </Box> */}
            </Box>
          </Box>
        ))}

      </Stack>

      <Elements.ModalBase open={openForm} confirmText="Save" handleClose={handleCloseForm} isLoading={isLoading} handleAgree={handleCreateAddon}>
        <Box fontSize={16} fontWeight="700">
          {fields.id ? 'Edit' : 'Create new'}
          {' '}
          addon
        </Box>
        <Box className="mt-3">
          <Stack direction="column" spacing={2}>
            <TextField value={fields.title} onChange={handleChangeField} name="title" label="Title" fullWidth size="small" />
            <TextField value={fields.price} onChange={handleChangeField} name="price" label="Price" fullWidth size="small" type="number" />
            <TextField value={fields.description} onChange={handleChangeField} name="description" label="Description" fullWidth size="small" />
            <TextField value={fields.extra} onChange={handleChangeField} name="extra" label="Extra storage" fullWidth size="small" type="number" />
          </Stack>
        </Box>
      </Elements.ModalBase>
    </div>

  );
}
